module.exports = __webpack_public_path__ + "img/logo.75377ae5.svg";